import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_textbox extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_textbox">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Textbox</h2>
              <p>
                Textboxes are the simplest yet most powerful way for a user to
                enter information into a data record. The textbox allows for
                free text entry and includes many features such as multiline,
                regex restrictions, and database uniqueness tests. Textboxes
                have a built-in one second delay to allow the user to stop
                editing a field before auto-save and other processes happen.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_textbox"}
                name={"textbox "}
                dataNameDefault={
                  '"text_my_db_text_field" or "long_my_db_number_field" or "object_my_obj.text_my_text_field"'
                }
                autoFill={'"my value" or 123'}
                padding={true}
                hide={true}
                order={true}
                button={true}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
                properties={[
                  {
                    property: "adornment_start_icon",
                    description:
                      "Material icon shown at the start of the textfield.",
                    defaults: '"face" default is null',
                  },
                  {
                    property: "adornment_start_icon_color",
                    description: "Set the adornment_start_icon color.",
                    defaults:
                      '"#D32F2F", "#FBC02D", "#388E3C" default is "rgba(0, 0, 0, 0.54)"',
                  },
                  {
                    property: "adornment_end_icon",
                    description:
                      "Material icon shown at the end of the textfield.",
                    defaults: '"face" default is null',
                  },
                  {
                    property: "adornment_end_icon_color",
                    description: "Set the adornment_end_icon color.",
                    defaults:
                      '"#D32F2F", "#FBC02D", "#388E3C" default is "rgba(0, 0, 0, 0.54)"',
                  },
                  {
                    property: "adornment_start_text",
                    description: "Text shown at the start of start textfield.",
                    defaults: '"$" default is null',
                  },
                  {
                    property: "adornment_end_text",
                    description: "Text shown at the end of start textfield.",
                    defaults: '"cm" default is null',
                  },
                  {
                    property: "alphanumeric",
                    description:
                      "Restricts user input to only alphanumeric characters.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "data_type",
                    warning: true,
                    description: "Textbox data type behaviour.",
                    defaults:
                      '"text", "text-multiline", "number", "currency", "hash" or "password-encrypt" default is "text"',
                  },
                  {
                    property: "decimals",
                    description:
                      'Numbers including decimals are stored in the database as whole numbers. This feature converts whole numbers to decimals. A value of 0 will treat the value as a whole number a value of 2 will divide number by 100 and show two decimals. This will only work with data_type "number".',
                    defaults: "0-8 default is 0",
                  },
                  {
                    property: "json",
                    description: "Check if input is valid JSON.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "lowercase",
                    description: "Changes user input to lowercase.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "max_length",
                    description:
                      'Set a maximum text length when in data_type is "text" or "text-multiline".',
                    defaults: "1-4000",
                  },
                  {
                    property: "min_length",
                    description:
                      'Set a minimum text length when in data_type is "text" or "text-multiline".',
                    defaults: "1-4000",
                  },

                  {
                    property: "number_thousands_separator",
                    description:
                      "Formats number and currency data types with thousand comma separator ie (1000000 vs 1,000,000)",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "max_rows",
                    description:
                      'Maximum rows of text when in data_type is "text-multiline".',
                    defaults: "1-1000 default is 1",
                  },
                  {
                    property: "min_rows",
                    description:
                      'Minimum rows of text when in data_type is "text-multiline".',
                    defaults: "1-1000 default is 1",
                  },
                  {
                    property: "no_space",
                    description: "Stops the user from entering an space.",
                    defaults: "true, false default false",
                  },
                  {
                    property: "phone_number",
                    description:
                      "Restricts users to only enter characters used in phone numbers (0-9, plus, space and brackets).",
                    defaults: "true, false default false",
                  },
                  {
                    property: "value_lowercase",
                    description: "Converts value to lowercase.",
                    defaults: "true, false default false",
                  },
                  {
                    property: "value_uppercase",
                    description: "Converts value to uppercase.",
                    defaults: "true, false default false",
                  },
                  {
                    property: "regex",
                    description:
                      "Test user input against a regular expression. Be aware that some regular expressions use JSON escape characters. You will need to replace a backslash with a double backslash.",
                    defaults: '"regular expression"',
                  },
                  {
                    property: "regex_failed_message",
                    description:
                      "Message displyed if users input fails a regular expression.",
                    defaults: '"Failed regular expression check."',
                  },
                  {
                    property: "time",
                    description:
                      "Restricts users to only enter characters used in 24 hour time (00-23:00-59).",
                    defaults: "true, false default false",
                  },
                  {
                    property: "time_duration",
                    description:
                      "Restricts users to only enter characters used in hours and minutes (HHHH:MM).",
                    defaults: "true, false default false",
                  },
                  {
                    property: "unique",
                    description: "Checks against database if value is unique.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "uppercase",
                    description: "Changes user input to uppercase.",
                    defaults: "true, false default false",
                  },
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Textbox Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Texbox</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_textbox"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"tab_index"</span>:{" "}
                  <span className="jsonP">10</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"hide"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Regular Expression Email</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_textbox"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_correspondence_email"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Correspondence Email"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"regex"</span>:{" "}
                  <span className="jsonY">
                    "
                    {
                      '^$|(^(([^<>()[\\\\]\\\\\\\\.,;:\\\\s@\\"]+(\\\\.[^<>()[\\\\]\\\\\\\\.,;:\\\\s@\\"]+)*)|(\\".+\\"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$)'
                    }
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"regex_failed_message"</span>:{" "}
                  <span className="jsonY">
                    "Please enter a valid email address."
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_textbox;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_textbox.js